export default "__VITE_ASSET__DaXqaJc2__"